import React from "react";
import QuestionSection from "./QuestionSection";
import { connect } from "react-redux";

class QuestionSections extends React.Component {

	render() {

		let sections = this.props.sections.filter(section => section.form === this.props.form).map(function (section, index) {
			return (
				<QuestionSection
					key={section.id}
					section={section}
					qsi={index+1}
					testObj={this.props.testObj}
				/>
			)
		}.bind(this));

		return (
			<div className="questionnaire__sections">
				{sections}
			</div>
		)
	}

}

export default connect(state => ({ sections: state.formSections}))(QuestionSections);


// WEBPACK FOOTER //
// ./src/modules/form/view.1/QuestionSections.js